'use client'

const Footer = () => (
    <footer className="flex gap-8 items-center justify-center bg-white text-black p-8">
        {/* <Image src='/assets/logo.svg' width={18} height={18} alt="logo"/> */}
        <p className="text-sm">Bsystems Limited © 2024. All Rights Reserved. </p>
    </footer>
)
export default Footer